module.exports = __webpack_public_path__ + "img/icon-waimai.93a46f17.png";